import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = { class: "flex flex-wrap gap-y-4 px-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "pr-6" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Chips = _resolveComponent("Chips")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_DataWrapper, {
        label: "Tipe Komisi",
        class: "w-6/12"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Chips, {
            class: "my-1",
            label: _ctx.configForwardCommission.commissionType
          }, null, 8, ["label"])
        ]),
        _: 1
      }),
      _createVNode(_component_DataWrapper, {
        label: "Acuan Komisi",
        class: "w-6/12",
        value: _ctx.titleCase(_ctx.configForwardCommission.commissionReference)
      }, null, 8, ["value"]),
      _createVNode(_component_DataWrapper, {
        label: "Parameter",
        class: "w-6/12",
        value: 
          _ctx.convertCommissionParameter(
            _ctx.configForwardCommission.commissionParameter
          )
        
      }, null, 8, ["value"]),
      _createVNode(_component_DataWrapper, {
        label: "Komisi",
        class: "w-6/12",
        value: _ctx.commission
      }, null, 8, ["value"])
    ]),
    _hoisted_3
  ]))
}